module.exports = __webpack_public_path__ + "static/media/icons8-mastercard.0eb4e539.svg";